import { render, staticRenderFns } from "./abreu-vineyards.vue?vue&type=template&id=71ae3608&scoped=true"
import script from "./abreu-vineyards.vue?vue&type=script&lang=js"
export * from "./abreu-vineyards.vue?vue&type=script&lang=js"
import style0 from "./abreu-vineyards.vue?vue&type=style&index=0&id=71ae3608&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ae3608",
  null
  
)

export default component.exports